
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp, langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  currency: {
    bb: '幣幣交易',
    bba: '幣幣賬戶',
    hy: '合約交易',
    jg: '交割合約',
    hya: '合約賬戶'
  },
  index: {
    h24: '24H量',
    header_title: ['數位資產交易就選' + window.GLOBAL.LANG_TITLE.tw],
    header_small_title:'完整的一站式区块链数字资产交易',
    header_msg: '安全 - 穩定 - 可信',
    register_title: '註冊一個 ' + window.GLOBAL.LANG_TITLE.tw + ' 全球站賬號 開始交易旅程',
    register_pl: '請輸入你的郵箱或手機',
    register: '註冊',
    featureTitleWhy: '為什麼選擇我們',
    featureTitle: '安全 · 穩定 · 可靠',
    featureMsg: '',
    featureList: [
      { icon: icon1, title: '安全的錢包技術', msg: ['冷、熱錢包技術由全球頂級的安全團隊開發,從未發生過丟幣事件。', ''] },
      { icon: icon2, title: '豐富的加密資產業務', msg: ['支持現貨和多種衍生品交易等,是您的進入加密資產世界的貼身管家。',''] },
      { icon: icon3, title: '分布在世界各地的客戶', msg: ['為全球超過130個國家或地區用戶,提供加密資產的全方位服務。',''] }
    ],
    bannerList: [
      { icon: banner01,title: "致力於提供業內 領先安全和穩定性", msg: ["智能合約保障投資人資產安全","交易績效真實","24h服務保障"] },
      { icon: banner02,title: "我想通過簡單操作立即買進賣出", msg: ["簡單的交易畫面","立即反映在您的賬戶余額中","大多數加密貨幣都可以交易"] },
      { icon: banner03,title: "我想通過交割合約交易積極賺取利潤", msg: ["開戶同時可用", "大量交易期貨的戰略投資","一年 365 天，一天 24 小時都可以交易，即使在周末也是如此"] }
    ],
    featureList2: [
      { icon: icon1_01, title: "透明開放", msg: ["運用區塊鏈與智能合約的特性，將交易績效真實上鏈，並使用智能合約保障投資人資產安全",""] },
      { icon: icon1_02, title: "智能投資", msg: ["經由頂尖的量化交易專家所提供的多樣化策略，任您自由選擇",""] },
      { icon: icon1_03, title: "風險分級", msg: ["依據各投資人不同風險與資產管理偏好設計出多元化的投資產品，有效消除投資門檻", ""] },
      { icon: icon1_04, title: "產品多元", msg: ["提供各類型用戶投資需求及彈性的平臺機製，持續產出優於市場的創新金融服務", ""] }
    ],
    featureTitle2: '隨時隨地 多平臺終端交易',
    featureMsg2: '覆蓋iOS、Android多個平臺,支持全業務功能',
    tab: ['主流幣', '24H 漲幅榜'],
    thead: ['名稱', '最新價格', '當日最高價', '當日最低價','漲幅榜', '24H成交量', '操作'],
    more: '查看更多 >',
    btn: '交易',
    dealsTitle: '一站式交易服務',
    dealsTab:[
      { title: '幣幣交易', content: '幣幣交易是針對數字資產之間的兌換,以USDT作為計價單位去購買其他幣種 。'+window.GLOBAL.LANG_TITLE.tw+'幣幣交易支持比特幣、以太坊、萊特幣等數字資產實時交易。', src:'/static/image/deals-1.jpg', path: '' },
      { title: '合約交易', content: '壹種數字貨幣的金融衍生品,不僅支持選擇買多或賣空合約來賺取收益,而且操作簡單,永不到期。'+window.GLOBAL.LANG_TITLE.tw+'合約具有先進的風險管理系統,杠桿最高可達100倍。', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['自選', '合約', '幣幣'],
    thead: ['幣種', '最新價', '24H漲跌幅', '24H最低', '24H最高','24H成交量', '操作'],
    nodata: '暫無數據'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.tw + '. All rights reserved.',
    dd: [
      {
        dt: "關於我們",
        dd: [{ title: "公司簡介", id: 1 }, { title: "幫助中心", type: 'help' }]
      },
      {
        dt: "用戶支持",
        dd: [
          { title: "用戶協議", id: 3 },
          { title: "隱私條款", id: 5 }
        ]
      },
      {
        dt: "聯系我們",
        icon: true
      }
    ]
  },
  nav: {
    btn: ["登錄", "註冊", "資產管理","下載APP"],
    nav: [
      { title: "首頁", path: "/index" },
      { title: "行情", path: "/market" },
      // { title: "幣幣交易", path: "/deal" },
      // { title: "合約交易", path: "/deal_c" },
      { title: "交割合約", path: "/deal_jg", name: 'deal_jg' },
      { title: "持倉返利", path: "/profit_index" }
    ],
    nav2: [{ title: "我的資產", path: "/asset" }],
    menus: [
      { icon: langzh, title: "賬戶設置", path: "/setting" },
      // { icon: langen, title: "交易日誌", path: "/deallog" },
      //{ icon: langzh, title: "身份認證", path: "/authentication" },
      { icon: langen, title: "退出登錄" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "下載"
  },
  // 登錄
  login: {
    login: '歡迎登錄',
    msg: '請輸入您已註冊的賬號',
    list: ['手機/郵箱', '密碼', '忘記密碼?', '登錄', '沒有賬號,立即註冊'],
    message: '賬號或密碼不能為空'
  },
  register: {
    dl: ['手機註冊', '郵箱註冊'],
    title: '註冊账户',
    country: '國籍',
    country_info: '國籍資訊注册後不可修改，請務必如實選擇',
    account: '賬號',
    code_text: '請輸入驗證碼',
    code_btn: '獲取驗證碼',
    code_unit: 's',
    code_no_data: '驗證碼不能為空',
    password_text: '請輸入密碼',
    password_again_text: '請再次輸入密碼',
    pid_text: '邀請碼',
    pid_pl: '选填',
    invitation_code_no_data: '邀請碼必填',
    xy: '用戶協議',
    xy_no_checked: '請選擇協議',
    agree: '我已閱讀並同意',
    register_btn: '註冊',
    bz: ['國籍信息註冊後不可修改,請務必如實選擇。', '驗證郵件可能會被誤判為垃圾郵件,請註意查收。', '請妥善保存您的' + window.GLOBAL.LANG_TITLE.tw + '賬號及登錄密碼。', '請勿和其他網站使用相同的登錄密碼。'],
    account_no_data: '賬號不能為空',
    code_no_equality: '驗證碼不相等',
    password_no_data: '密碼不能為空',
    password_no_equality: '兩次密碼不相等'
  },
  // 設置密碼
  bindmpwd: {
    title: '設置密碼',
    account: '賬號',
    code_text: '請輸入驗證碼',
    code_btn: '獲取驗證碼',
    code_unit: 's',
    password_text: '請輸入密碼',
    password_again_text: '請再次輸入密碼',
    code_no_data: '驗證碼不能為空',
    code_no_equality: '驗證碼不相等',
    password_no_data: '密碼不能為空',
    password_no_equality: '兩次密碼不相等',
    bindmpwd_btn: '確認',
    phone_no_data: '手機號碼不能為空',
    password_login_text: '請輸入登錄密碼',
    password_trade_text: '密碼長度6位數字',
    password_again_tarde_text: '密碼長度6位數字',
  },
  // 忘記密碼
  forgetpwd: {
    title: ['修改密碼', '忘記密碼'],
    account: '賬號',
    code_text: '請輸入驗證碼',
    code_btn: '獲取驗證碼',
    code_unit: 's',
    password_text: '請輸入密碼',
    password_again_text: '請再次輸入密碼',

    phone_no_data: '手機號碼不能為空',

    account_no_data: '賬號不能為空',
    code_no_data: '驗證碼不能為空',
    code_no_equality: '驗證碼不相等',
    password_no_data: '密碼不能為空',
    password_no_equality: '兩次密碼不相等',
    forgetpwd_btn: '確認'
  },
  // 綁定手機號碼
  bindphone: {
    title: '綁定手機號碼',
    phone_text: '手機號',
  },
  person: {
    more: '加載更多',
    no_more: '沒有數據了',
    index_center:"用戶中心",
    index_menus: [
      { icon: zhsz, title: "賬戶管理", path: '/setting' },
      { icon: sfrz, title: "身份驗證", path: '/sfyz' },
      { icon: sfrz, title: "初級認證", path: '/smauth' },
      { icon: jtrz, title: "高級認證", path: '/seniorauth' },
      { icon: jtrz, title: "地址認證", path: '/dzrz' },
      { icon: jtrz, title: "快捷買幣", path: '/kjmbSelect' },
      { icon: jtrz, title: "信用分", path: '/credit' },
      { icon: jtrz, title: "賬戶記錄", path: '/deallog' },
      { icon: jtrz, title: "充幣記錄", path: '/cbjl' },
      { icon: jtrz, title: "提幣記錄", path: '/tbjl' },
    ],
    cbtb: '充幣提幣',
    jymx: '交易明細',
    xyf: {
      'title': '信用分',
      'pgsj': '評估時間'
    },
    smrz:{
      title:'實名認證',
      sure_title:'您已通過實名認證',
      zj_type:'證件類型',
      zj_info:['1、認證資訊一經驗證不可修改,請務必如實填寫','2、被認證的實名資訊不能重複認證'],
      zj_name:'姓名',
      zj_num:'證件號碼',
      zj_btn:'確定',
      zj_rebtn:'重新驗證',
      zj_sebtn:'高級驗證',
      zj_type_array:[{name:'身份證',type:'idcard'}],
      idCardArr: [
        {
            id: 1,
            name: "身份證"
        },
        {
            id: 2,
            name: "護照"
        },
        {
            id: 3,
            name: "駕駛證"
        },
        {
            id: 4,
            name: "居留證"
        },
        {
            id: 5,
            name: "其它"
        }
      ],
      zj_data:{city:'國籍不能為空',type:'證件類型不能為空',name:'姓名不能為空',zj_num:'證件號碼不能為空'},
      zsxm: '真實姓名',
       qsrzsxm: '請輸入真實姓名',
       zjlx: '證件類型',
       qxzzjlx: '請選擇證件類型',
       sfz: '身份證',
       zjhm: '證件號碼',
       qsrzjhm: '請輸入證件號碼',
       sczjz: '上傳證件照',
       zjzm: '上傳證件正面照',
       zjfm: '上傳證件背面照',
       qsczjzm: '請上傳證件正面照',
       qsczjfm: '請上傳證件背面照',
       scqmz: '上傳證件與個人簽名照',
       qscscqmz: '請上傳證件與個人簽名照',
       zj: [
         {
           id: 1,
           title: '身份證'
         },
         {
           id: 2,
           title: '護照'
         },
         {
           id: 3,
           title: '其他'
         },
       ],
       tj: '提交',
       shz: '審核中',
       shtg: '審核通過'
      },
      gjrz:{
      title:'高級認證',
      zj_info:['1、支持小於8M的JPG、JPEG或PNG格式圖片。','2、證件照片要求清晰,不允許任何修改和遮擋,必須能看清人像、證件號和姓名。','3、照片需免冠,建議未化妝,手持證件人的五官清晰可鑒,完整露出手臂'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

      },
      zhgl:{
      title:'安全設置',
      bind:[{bind_title:'重置密碼',bind_name:'郵箱'},{bind_title:'設置交易密碼',bind_name:'郵箱'}]

      },
      wdtg:{
              own_code:'專屬邀請碼',
              own_code_url:'專屬邀請連接',
              own_push_title:'我的推廣',
              own_push_content:['邀請總收入（估值）','邀請人數','人'],
              own_push_content_profit:['一級邀請收益','二級邀請收益','三級邀請收益','四級邀請收益'],
              own_push_content_num:['一級邀請人數','二級邀請人數','三級邀請人數','四級邀請人數'],
              own_push_profit_title: ['ID', '收益', '備註信息','添加時間'],
              own_push_num_title: ['ID', '名稱', '電話','添加时间'],

      },
    jyzt_td: ['時間', '詳情', '金額'],
    cbjl_td: ['時間', '幣種', '數量','狀態'],
    sfrz_txt: ['身份認證', '您已經提交稽核請等待結果', '您已通過高級認證', '身份證正面', '身份證反面', '認證','認證失敗,請重新認證'],

    zhsz_txt: ['您的賬號安全等級: #', '您的賬號安全等級: #,完善更多資料,保證賬號安全'],
    zhsz_m: '強',
    zhsz_n: '弱',
    zhsz_p: '不安全',
    zhsz_detailList: [
      // { icon: iconchecked, title: '我的邀請碼', value: '', btn: '復制邀請碼', class: 'copy', event: 'copy' },
      // { icon: '/static/image/User_Center-email.png', title: '邮箱', value: '用於登入、提幣、安全設置時使用',value2:'', btn: '绑定', btn2: '去绑定', path2: '/bindphone' },
      // { icon: '/static/image/User_Center-phone.png', title: '手機', value: '用於提現，修改密碼，安全設置時用以收取驗證簡訊', value2:'',btn: '绑定', btn2: '去綁定', path2: '/bindphone' },
      { icon: '/static/image/User_Center-password.png', title: '登錄密碼', value: '互聯網賬號存在被盜風險,建議您定期更改密碼以保護賬號安全。', value2:'',btn: '修改', bind_email:'請先綁定郵箱或者手机',path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: '交易密碼', value: '設置交易密碼', btn: '去設置', path: '/bindmpwd' }
    ],
    sksz_txt: ['收款設置', '保存'],
    sksz_list: [
      { label: "用戶名:", pl: "請輸入用戶名", key: "name" },
      { label: "開戶行名稱:", pl: "請輸入開戶行名稱", key: "bank_name" },
      { label: "銀行卡號:", pl: "請輸入銀行卡號", key: "bank_number" },
      { label: "支付寶賬號:", pl: "請輸入支付寶賬號", key: "alipay_account" },
      { label: "微信昵稱：", pl: "請輸入微信昵稱", key: "weixin_nickname" },
      { label: "微信賬號：", pl: "請輸入微信賬號", key: "weixin_account" }
    ]
  },
  pasination: {
    first: '首頁',
    prev: '上一頁',
    next: '下一頁',
    last: '尾頁',
    no_data: '暫無數據',
  },
  asset: {
    title: '我的資產',
    zjhz: '資金劃轉',
    cb: '充幣',
    gz: 'USDT估值',
    atnv: [],
    zh_title: '總資產折合：',
    index_title: '資產',
    address_title: '幣種',
    address_txt: ['請選擇', '提幣地址', '請輸入內容', '備註', '地址列表'],
    address_btn: ['添加', '保存', '刪除', '編輯'],
    address_td: ['幣種', '提幣地址', '備註', '操作'],
    currency_td: ['幣種', '可用', '凍結', '折合'],

    table_title: '總資產：',
    table_address_title: '提幣地址管理',
    table_td: ['幣種', '可用', '凍結', '折合', '操作'],
    table_btn: ['充幣', '提幣', '記錄', '劃轉'],

    money_text: ['提幣地址', '請選擇', '數量', '可用：', '手續費',
      '到賬數量', '交易密碼','標簽(Memo)','最低提幣 '],
    money_btn: '提幣',
    xzbz: '選擇幣種',
    money_msg: ['溫馨提示', '請勿向上述地址充值任何非USDT資產,否則資產將不可找回。', 'USDT充幣僅支持simple send的方法,使用其他方法（send all）的充幣暫時無法上賬,請您諒解。'],

    recharge_title: '充值地址',
    recharge_btn: ['復制', '二維碼', '充幣'],
    recharge_text: ['數量', '溫馨提示', '請勿向上述地址充值任何非USDT資產,否則資產將不可找回。', 'USDT充幣僅支持simple send的方法,使用其他方法（send all）的充幣暫時無法上賬,請您諒解。', '憑證', '憑證描述(選填)','链名称'],

    record_title: '財務記錄',
    record_td: ['數量', '記錄', '時間'],

    transfer_title: '劃轉',
    transfer_btn: ['全部', '轉賬'],
    transfer_text: ['從', '至', '請輸入劃轉數量', '可用：'],
    "bq": "標簽(Memo)",
   "qsrbq":"請輸入標簽",
   "yhktx":"銀行卡提現",
   "yhmc": "銀行名稱",
   "qsryhmc": "請輸入銀行名稱",
   "yhzh": "銀行賬號",
   "qsryhzh":"請輸入銀行賬號",
   "gjhkdm": "國際匯款代碼",
   "qsrgjhkdm":"請輸入國際匯款代碼",
   "yhdz": "銀行地址",
   "qsryhdz":"請輸入銀行地址",
   "skrxm": "收款人姓名",
   "qsrskrxm":"請輸入收款人姓名",
   "skrdh": "收款人電話",
   "qsrskrdh":"請輸入收款人電話",
   "skrdz": "收款人地址",
   "qsrskrdz":"請輸入收款人地址"
  },
  text: {
    btn: '返回',
    login: '請先登錄'
  },
  deal: {
    chooseType: '委托類型',
    choose: '請選擇',
    balance: '余額：',
    account: ['賬戶', '可用', '/凍結', '劃轉'],
    dir: ['買', '賣'],
    dir2: ['可買', '可賣'],
    sxf: '手續費',
    jye: '交易額',
    cs: '自選',
    sc_list: ['市場', '名稱', '漲幅'],
    sc_h: ['當前價格', '24H最低價', '24H最高價', '24H成交量'],
    td_lt: ['幣種', '最新價', '漲幅'],
    k_line_txt: ['≈', '', '漲幅', '最高價', '最低價', '24H量'],
    tabListLTitle: ["當前委托", "歷史委托"],
    tabListLEntrust: ["買入", "賣出"],
    tabListRTitle: ["限價交易", "市價交易"],
    table_btn: ['撤單'],
    index_td_l: ['時間', '交易對象', '數量', '價格', '操作'],
    index_td_r: ['最新價', '方向', '價格', '數量'],
    index_td_r2: ['最新交易', '時間', '價格', '交易量'],
    table_txt: ['已完成', '已撤單'],

    db_1_txt: ['可用', '買入價', '賣出價', '買入量', '賣出量', '交易額', '以市場最優價格買', '以市場最優價格賣','買入手', '賣出手'],
    db_2_txt: ['價格', '杠桿', '請選擇', '手數', '1手 = ', '手', '合約市值', '保證金', '以市場最優價格買', '以市場最優價格賣'],
    pathList: ['合約記錄', '交易記錄'],
    db_btn: ['買入(做多)', '賣出(做空)'],
    tabListLTitle2: ['當前委托'],

    lt_btn: ['一鍵平倉', '設置止盈止損價', '平倉', '立即提交', '返回'],
    lt_txt: ['風險率：', '持倉總盈虧：'],
    lt_td: ['類型', '杠桿倍數', '持倉價', '當前價', '保證金', '止盈價', '止損價', '開倉時間', '手數', '盈虧', '操作'],
    lt_dl: ['設置止盈止損價', '止盈價', '止損價'],

    lt_0_btn: ['撤單'],
    lt_0_td: ['聯系方式', '幣種', '數量', '當前價', '手續費', '操作'],

    lt_1_btn: ['平倉'],
    lt_1_txt: ['平倉中'],
    lt_1_td: ['類型', '持倉價', '當前價', '保證金', '止盈價', '止損價', '開倉時間', '手續費', '盈虧', '操作'],
    node_data: '暫無數據',

    lt_3_txt: ['已平倉', '爆倉'],
    lt_3_td: ['類型', '手數', '持倉價', '平倉價', '止盈價', '止損價', '保證金', '可用保證金', '開倉時間', '平倉時間', '手續費',
      '盈虧', '操作'],

    lt_4_txt: ['已撤單'],
    cm: ['發行時間', '發行總量', '流通總量', '總湊價格', '官網','白皮書','介紹'],
    qsrsl: '請輸入數量',
    qsrss: '請輸入手數',
  },
  notice:{
      notice_title:'公告中心',
  },
  bzhl:{
    title: '持倉返利',
    ttzbt: '天天賺不停',
    wdtg: '我的托管',
    zztgdzj: '正在托管的資金',
    yjjrsy: '預估日收益',
    ljsy: '累計收益',
    tgzdd: '托管中訂單',
    tgdd: '托管訂單',
    t1: '低風險穩健理財，有需要可隨時贖回',
    t2: '您的閑錢管理小助手',
    cljxcp: '產品周期',
    dbxe: '單筆限額',
    rsyl: '報酬率(%)',
    rsyl2: '日收益率：',
    zq: '周期',
    qmr: '去買入',
    ckgd: '查看更多',
    cpgk: '產品概況',
    pxsj: '派息時間',
    tgzj: '托管資金',
    tqsh: '提取贖回',
    cpld: '產品亮點',
    cpgz: '產品規則',
    cont: '搬磚是通過將USDT托管給平臺，由平臺的專業團隊進行搬磚權利，參與者在資金托管期間可獲得平臺的搬磚收入分成，可隨時存取，安全又便捷。',
    zj: '100%資金',
    aqbz: '安全保障',
    jjrsy: '節假日收益',
    bjd: '不間斷',
    cgcrh: '成功存入後',
    dtqx: '當天起息',
    ljzr: '立即轉入',
    xqglgj: '閑錢管理工具',
    ddh: '訂單號',
    tgje: '托管金額',
    tgsj: '周期天數',
    yhl: '已獲利/剩余天數',
    xdsj: '下單時間',
    zt: '狀態',
    fh: '返回',
    qrnhsy: '七日年化收益',
    ygy: '1個月',
    bn: '半年',
    yn: '1年',
    yuan: '元',
    tzfx: '投資風險',
    shsc: '贖回時長',
    di: '低',
    yggzr: '一個工作日',
    msgsxf: '免申購手續費',
    mr: '每日',
    dqfh: '到期返還',
    ljgm: '立即購買',
    tgz: '托管中',
    sh: '贖回',
    ywc: '已完成',
    ysh: '已贖回',
    all: '全部',
    "xzbzts": "簡單，安全。可選擇多種幣種進行派息",
    "qtbz": "其它幣種"
  },
  pay:{
    qsrjymm: '請輸入6位交易密碼',
    tbmmts: '請到用戶中心設置交易密碼',
  },
  tips:{
    qxztbdz: '請輸入提幣地址',
    qsrtbsl: '請輸入提幣數量'
  },
  statusText: ['失敗','等待處理','成功'],
  dzrz: {
    title: '地址認證',
    sdddz: '水電單地址',
    zdtpsc: '賬單圖片上傳',
    qsrsdddz: '您需要填寫地址信息和提交水電費或者寬帶地址的賬單',
    qsczdtp: '請上傳賬單圖片'
  },
  jgcc: {
    wtgd: '委托掛單',
    cj: '成交',
    jj: '簡介',
    zc: '在持',
    lszc: '歷史持倉',
    qblx: '全部類型',
    xj: '現價',
    sj: '時間',
    fx: '方向',
    jg: '價格',
    sl: '數量',
    jgsj: '交割時間',
    gmj: '購買價',
    jsj: '結算價',
    yk: '盈虧',
    xq: '詳情',
    mz: '買漲',
    md: '買跌',
    dqye: '當前余額',
    gb: '關閉',
    jxxd: '繼續下單',
    qrxd: '確認下單',
    ddqr: '訂單確認',
    sxf: '手續費',
    kyye: '可用余額',
    jypz: '名稱',
    jyfx: '交易方向',
    tzje: '投資金額',
    tzjeTips: '投資金額不能為0',
    dqsj: '到期時間',
    jssj: '結算時間',
    gmsj: '購買時間',
    sy: '收益',
    zxje: '最小數量 ',
    shi: '時',
    fen: '分',
    miao: '秒',
    zdje: '最大數量 ',
    qsrje: '請輸入金額',
    zxtzje: '最低數量 ',
    yebz: '余額不足',
    xq: '詳情',
    ddz: '等待中',
    jgjl: '交割記錄',
    bz: '幣種',
    cz: '操作'
  },
  kjmb: {
    title: '快捷買幣',
    fzcg: '復製成功',
    ljmb: '立即買幣',
    lxkf: '聯系客服'
  },
  news: {
    title: '我的消息',
    "gg": "公告",
    ckxq: '查看詳情'
  },
  statusTabs:['掛單中', '交易中','已平倉', '已撤單'],
  "chongzhi":{
    "zy": "註意",
    "cbxx": "充幣信息",
    "qsrsl": "請輸入充幣數量",
    "tips2": "1.錢包/平臺的兼容：即對該網絡支持；如目標平臺不支持您的提幣網絡，將導致資產無法找回。",
    "tips3": "2.您充值網絡和目標平臺是一致的；如您選擇了目標地址是以太坊網絡，但充值選擇了TRC20智能鏈，您或將無法找回您的數字資產。",
    "tips4": "3.充值前確保您的地址、金額正確。",
    "tips5": "溫馨提示：由於區塊網絡匿名和私密，一旦輸入錯誤信息，您將損失對應資產。請務必仔細核對您的充值地址及數量",
    "tips2_1": "• 請勿向上述地址充任何非本幣種資產，否則資產不可找回。",
    "tips2_2": "• 數字貨幣無法及時到賬，實際到賬時間取決於區塊鏈確認速度。",
    "tips2_3": "• 您的充值地址不會經常改變，可以重復充值；如有更改，我們會盡量通過網站公告或郵件通知您。",
  },
  "tibi":{
    "tbxx":"提幣信息",
    "qsrbq": "請輸入標簽",
    "tbTips1": "• 為保障資金安全，當您賬戶安全策略變更、密碼修改、我們會對提幣進行人工審核，請耐心等待工作人員電話或郵件聯系。",
    "tbTips2": "• 請務必確認電腦及瀏覽器安全，防止信息被篡改或泄露。",
    "tbTips3": "• 您所提的數字資產為一幣多鏈資產，無論您選擇從哪個鏈上提出，均意味著您所擁有的該提幣頁面展示的數字資產總量減少相應的提出數量。",
  },
  "gjlb": "國家列表",
  "qxzgjlb": "請選擇國家/地區",
  "mbwt":{
    "title": "密保問題設置",
    "mbwt": "密保問題",
    "problem":[
      {
        "id": 1,
        "title": "您小時候最好的朋友是？"
      },
      {
        "id": 2,
        "title": "您的偶像是？"
      },
      {
        "id": 3,
        "title": "您最向往的地方是哪裏？"
      }
    ],
    "qtxda": "請填寫答案",
    "qsrxmm": "請輸入新密碼",
    "qqrmm": "請確認密碼",
    "sydqmmcz": "使用當前密碼重置",
    "zhmm": "密保問題找回密碼",
    "ysz": "已設置",
    "tg": "跳過",
  "tj": "提交",
  "zyts": "重要提示：",
  "zytsCont": "請勿泄露密保答案和驗證碼，並牢記密保問題，這將有助於您找回密碼"
  },
  "zc":{
    "zclb": "資產列表",
    "zczh": "資產折合",
    "yczc": "隱藏為0的資產"
  },
  "indexNew":{
    "t1": "全球領先的",
    "t2": "數字資產服務平臺",
    "t3": "完整的一站式區塊鏈數字資產交易",
    "t4": "手機號/郵箱",
    "t5": "立即註冊",
    "t6": "歡迎世界各地的客戶通過 GMO Global",
    "t7":"發現並開始他們的加密之旅"
  },
  "newReg":{
    "dl": ['郵箱','手機'],
    "cjzh": "創建賬戶",
    "sysjhzyx": "使用手機號/電子郵箱註冊",
    "yhxy": "《用戶協議》",
    "yhxy2": "我已閱讀並同意《用戶協議》",
    "yxgz": "輸入的郵箱不符合規則",
    "dhgz": "輸入的手機號碼格式有誤"
  },
  "indexNew2":{
    "t1": "在我們的訂單上交易",
    "t2": "使用比特銀行",
    "t3": "比特銀行是一種設計巧妙的比特幣和加密資產交換，非常簡單、方便、安全且功能強大。在多個web和智能手機平臺上支持交易。交易數據和圖表實時更新，為全面    市場價格分析提供60多種技術分析工具。開始交易",
    "ksjy": "開始交易",
    "ly": "選擇Bitbank的5個理由",
    "item1_t1": "交易量領先",
    "item1_t2": "No.1 * 加密資產交易量",
    "item1_t3": "高流動性，舒適（愉快的交易體驗）交易。列出 12 種加密資產。",
    "item2_t1": "第三方評價高",
    "item2_t2": "安全的交易環境",
    "item2_t3": "采用離線冷錢包。通過 Multisig 將黑客拒之門外。以高科技保護您的資產",
    "item3_t1": "易於使用且可靠的應用程序",
    "item3_t2": "易用簡便的應用程序",
    "item3_t3": "具有豐富功能的可靠應用程序。可在外交易保持交易機會。",
    "item4_t1": "全日無休",
    "item4_t2": "可入金",
    "item4_t3": "24 小時存款支持，包括假期！",
    "item5_t1": "智能手機和PC",
    "item5_t2": "人性化設計",
    "item5_t3": "即使使用智能手機也可以毫不猶豫地進行簡單合格的交易",
    "aqkk": "安全可靠",
    "aqkk2": "比特銀行的比特幣交易",
    "cjzh": "創建一個賬戶",
  },
  "xbsg":{
    "title": "新幣申購",
    "wdsg": "我的申購",
    "scts": "鎖倉天數：",
    "sy": "剩余",
    "ljsg": "立即申購",
    "ysk": "已售空",
    "xzjdy": "現在就訂閱",
    "dy": "訂閱",
    "fxjg": "發行價格",
    "fxl": "發行量",
    "ssrq": "上市日期",
    "yxqx": "有效期限",
    "qsrsl": "請輸入數量",
    "syl": "剩余量",
    "sgrq": "申購日期",
    "sgsl": "申購數量",
    "bz": "幣種",
    "yebz": "USDT余額不足",
    "tgsl": "通過數量",
    "shz": "審核中",
    "wtg": "未通過",
    "ytg": "已通過"
  },
  "wydb":{
    "title": "我要貸幣",
    "db": "貸幣",
    "dbz": "貸幣中",
    "jl": "記錄",
    "jdzq": "借貸周期(天)",
    "qhk": "去還款",
    "ljdb": "累計貸幣(usdt)",
    "dhkbs" :"待還款筆數",
    "jkje": "借款金額(usdt)",
    "qsrje": "請輸入金額",
    "rll": "日利率",
    "hkfs": "還款方式",
    "dqych": "到期一次還本息",
    "lx": "利息",
    "fkjg": "放款機構",
    "tpsc": "信用貸款(圖片上傳)",
    "fwxx": "房屋信息",
    "srzm": "收入證明(雇傭關系)",
    "yhmx": "銀行明細",
    "zjz": "證件照",
    "yd": "本人已閱讀並同意",
    "xy": "申請貸幣協議",
    "sqdb": "點擊申請貸幣",
    "gb": "關閉",
    "qd": "確定",
    "ts": "請勾選申請貸幣協議",
    "dbjl": "貸幣記錄",
    "hkhth": "貸款合同號",
    "wsh": "未審核",
    "yfk": "已放款",
    "sqrq": "申請日期",
    "zq": "周期",
    "dbsl": "貸幣數量",
    "zhke": "總還款額",
    "yhkxq": "應還款詳情",
    "bqyhk": "本期應還款（USDT）",
    "hktips": "請確保余額充足，余額不足請先充值再還款",
    "bj": "本金",
    "jie": "借",
    "ljhk": "立即還款",
    "qcz": "去充值",
    "yebzqxcz": "余額不足，請先充值再還款",
    "znj": "滯納金",
    "yqts": "逾期天數"
  },
  "hkxq":{
    "dd":"訂單",
    "fzhkdz":"復製還款地址",
    "hkxq": "還款詳情",
    "zlx": "總利息",
    "zhk": "總還款",
    "hkjg": "還款機構",
    "qschkpz": "請上傳還款憑證",
    "hkpz": "還款憑證"
  },
  "bbjyNew":{
    "jylx": "交易類型",
    "jyze": "交易總額"
  },
  "bind":{
    "title": "郵箱認證",
    "ybd": "已綁定",
    "wbd": "未綁定",
    "ts": "為保護您的賬戶，建議綁定郵箱",
    "qsryxdz": "請輸入郵箱地址"
  },
  "tipsNew": {
    "yjj": "已拒絕",
    "shz": "贖回中"
  },
  "newIndex2":{
    "zxhy": "最新行情",
    "jypt": "交易平台",
    "dqwz": "當前位置",
    "yzm": "驗證碼",
    "qrmm": "確認密碼",
    "djdl": "點擊登錄",
    "ghdjy": "更好的交易",
    "ghdsh": "更好的生活",
    "about": "世界上最具創新性的加密交易中心就在這裡，您可以購買、交易和賺取加密貨幣，觸手可及的加密貨幣多達數百種。",
    "index01": "您通往比特幣及其他領域的門戶",
    "index02": "全球領先的數字資產服務平台",
    "index03": "各種交易都是免費的",
    "index04": "開戶費、賬戶維護費、止損費、押金費、倉儲/送貨費全部免費。",
    "index05": "安全可靠的安保",
    "index06": "利用 GMI INT 自成立以來積累的專業知識，我們正在構建強大的系統並實施各種安全措施，以安全可靠地保護客戶的資產。",
    "index07": "實物交易和槓桿交易均可用",
    "index08": "小額交易可以從10美元左右進行，點差是業內最窄的，可以以賬戶餘額作為抵押進行槓桿交易，只有GMI INT可以收取槓桿費用。",
    "index09": "旨在增強GMI INT社區能力的代幣",
    "index10": "Unus Sed LEO為應用型代幣，旨在協助尋求GMI INT交易平台最大化效益及功能的用戶符合其需求。",
    "index11": "旨在增強GMI INT社區能力的代幣",
    "index12": "開啟通往美好生活的道路",
    "index13": "每個人都可以擁有加密。每個人都可以交易加密軟件。以下是Bitget如何讓您更進一步。",
    "index14": "創新產品",
    "index15": "一鍵複製交易",
    "index16": "交易時不轉換代幣",
    "index17": "支持USDC保證金的主要衍生品交易所",
    "index18": "通過冷熱錢包隔離進行風險控制",
    "index19": "12 a+來自SSL實驗室的評級",
    "index20": "受Suntwin技術、青松雲安全、HEAP和Armors支持的可信安全",
    "index21": "卓越的客戶服務",
    "index22": "全天候多語言在線支持",
    "index23": "對VIP客戶的一對一支持",
    "index24": "社區獎勵中心",
    "index25": "由交易者為交易者建造",
    "index26": "以低交易成本交易各種數字資產，如比特幣、以太坊、Solana 和 dogcoin",
    "index27": "您購買、出售、交易、投資和使用加密貨幣所需的工具和信息",
    "index28": "業界領先的安全性",
  },
  "langNew":{
    "szhb": "數字貨幣",
    "gjs": "貴金屬",
    "yy": "原油",
    "jy": "交易",
    "jmhb": "加密貨幣",
    "yxhy": "永續合約",
    "gdjy": "掛單交易",
    "khh": "開戶行",
    "qsrkhh": "請輸入開戶行",
    "yhkh": "銀行卡號",
    "qsryhkh": "請輸入銀行卡號",
   }
}



// WEBPACK FOOTER //
// ./src/lang/tw.js